module.exports = __webpack_public_path__ + "img/step34_a_printer_power_place_printer - Copy.dbd128d7.png";